import React from 'react';
import personImg from 'assets/person.png';

const Leaders = (): JSX.Element => {
	const items = [
		{
			id: '1',
			name: 'John Doe',
			points: '150',
		},
		{
			id: '2',
			name: 'John Doe',
			points: '50',
		},
		{
			id: '3',
			name: 'John Doe',
			points: '19',
		},
	];

	const data = [
		{
			id: 1,
			title: 'Strategic Thinking',
			items,
		},
		{
			id: 2,
			title: 'Communication',
			items,
		},
		{
			id: 3,
			title: 'Expertise',
			items,
		},
	];

	return (
		<div className="leaders">
			{data.map(({ id, title, items }) => (
				<table key={id}>
					<thead>
						<tr>
							<td colSpan={3} className="title">
								{title}
							</td>
						</tr>
					</thead>
					<tbody>
						{items.map(({ id, name, points }) => (
							<tr key={id}>
								<td>
									{id}.
								</td>
								<td>
									<div className="name-wrapper">
										<img src={personImg} alt="person" className="thumbnail small"/>
										<h3 className="name">
											{name}
										</h3>
									</div>
								</td>
								<td>
									{points} points
								</td>
							</tr>
						))}
					</tbody>
				</table>
			))}
		</div>
	);
};

export default Leaders;
